<template>
  <section id="treatments">
    <section-container class="mt-10 mb-0 pb-0">
      <div class="text-center mb-6">
        <text-h2>{{ heading }}</text-h2>
      </div>
      <div class="">
        <ul role="list" class="mt-3 grid grid-cols-2 sm:gap-6 lg:grid-cols-4">
          <li
            v-for="treatment in treatments"
            :key="treatment.name"
            class="col-span-1 w-full"
          >
            <div class="flex flex-col py-2">
              <div class="flex-1 text-sm flex flex-col items-center justify-start">
                <component :is="treatment.icon" class="w-28 lg:w-32" />
                <div class="text-lg font-semibold w-32 text-center">
                  {{ treatment.name }}
                </div>
                <component v-if="treatment.image" :is="treatment.image" class="-mt-1" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section-container>
  </section>
</template>

<script setup>
defineProps({
  treatments: {
    type: Array,
    default: () => [],
  },
});

const heading = "Book a Consultation to Discuss Treatment Options Today";
</script>
